// extracted by mini-css-extract-plugin
module.exports = {"container":"NoteIcon_container__27gvd","noteIcon":"NoteIcon_noteIcon__K9JQu"};